import './index.scss'
import DeveloperMain from '../../../assets/images/developer-image3.png'

const Logo = () => {
  return <img src={DeveloperMain} className="solid-logo" alt=""></img>
}

export default Logo
